import { render, staticRenderFns } from "./PartnerLocatorDirectory.vue?vue&type=template&id=159c58b5"
import script from "./PartnerLocatorDirectory.vue?vue&type=script&lang=js"
export * from "./PartnerLocatorDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports